import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Clock, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";
import { COMPANY, NAV_LINKS, SERVICES } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-[#061325] text-slate-300" data-testid="site-footer">
      <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr] lg:gap-8">
        <div>
          <Logo />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            LKTH LTD builds secure, scalable web portals and IT solutions for UK businesses —
            designed, developed and supported from Sheffield.
          </p>
          <p className="mt-5 font-mono-alt text-xs uppercase tracking-[0.2em] text-blue-400">
            Secure · Scalable · Reliable
          </p>
        </div>

        <nav aria-label="Quick links">
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-white">Quick Links</h3>
          <ul className="mt-5 space-y-3 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="inline-flex items-center gap-1 text-slate-400 transition-colors hover:text-blue-400" data-testid={`footer-link-${l.path === "/" ? "home" : l.path.slice(1).replace("-", "")}`}>
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/privacy-policy" className="text-slate-400 transition-colors hover:text-blue-400" data-testid="footer-link-privacy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms" className="text-slate-400 transition-colors hover:text-blue-400" data-testid="footer-link-terms">Terms &amp; Conditions</Link>
            </li>
            <li>
              <Link to="/cookie-policy" className="text-slate-400 transition-colors hover:text-blue-400" data-testid="footer-link-cookies">Cookie Policy</Link>
            </li>
          </ul>
        </nav>

        <nav aria-label="Services links">
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-white">Services</h3>
          <ul className="mt-5 space-y-3 text-sm">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.slug}>
                <Link to={`/services#${s.slug}`} className="text-slate-400 transition-colors hover:text-blue-400" data-testid={`footer-service-${s.slug}`}>
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-white">Get in Touch</h3>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-blue-400" aria-hidden="true" />
              <span className="text-slate-400">{COMPANY.addressLines.join(", ")}</span>
            </li>
            <li>
              <a href={COMPANY.phoneHref} className="flex gap-3 text-slate-400 transition-colors hover:text-blue-400" data-testid="footer-phone-link">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-blue-400" aria-hidden="true" />
                {COMPANY.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} className="flex gap-3 break-all text-slate-400 transition-colors hover:text-blue-400" data-testid="footer-email-link">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-blue-400" aria-hidden="true" />
                {COMPANY.email}
              </a>
            </li>
            <li className="flex gap-3">
              <Clock className="mt-0.5 h-4 w-4 shrink-0 text-blue-400" aria-hidden="true" />
              <span className="text-slate-400">{COMPANY.hours}</span>
            </li>
          </ul>
          <Link to="/contact" className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-blue-400 transition-colors hover:text-blue-300" data-testid="footer-cta">
            Start your project <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-6 text-xs text-slate-500 sm:flex-row">
          <p>© 2026 LKTH LTD. All rights reserved. Registered in England &amp; Wales.</p>
          <p className="font-mono-alt">Company No. [registration number to follow]</p>
        </div>
      </div>
    </footer>
  );
}
